import { render, staticRenderFns } from "./PhonePreview.vue?vue&type=template&id=545e8b20&scoped=true&"
import script from "./PhonePreview.vue?vue&type=script&lang=js&"
export * from "./PhonePreview.vue?vue&type=script&lang=js&"
import style0 from "./PhonePreview.vue?vue&type=style&index=0&id=545e8b20&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545e8b20",
  null
  
)

export default component.exports